import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

import Navbar from './components/Navbar';
import QRScanner from './components/QRScanner';
import Banner from './components/Banner';
import imgBadge1 from "../images/badge-1.png";
import imgBadge2 from "../images/badge-2.png";
import { useOnlineStatus } from '../hooks/useOnlineStatus';

const Scan = () => {

    const [code, setCode] = useState();
    const isOnline = useOnlineStatus();

    const [storedSession, setStoredSession] = useState([]);
    const [selectedSession, setSelectedSession] = useState([]);

    const sessionItems =
        ["Apple & Brack Business", "Axis Communications", "Barco", "Dell Technologies", "Gigaset",
            "Hewlett-Packard", "HP Inc", "Huawei", "ICY BOX", "Lenovo", "Microsoft", "Mitel", "Pax8",
            "QNAP", "Qualcomm Compute", "Snom", "Synology", "Targus", "TRIOTRONIK / Ubiquiti UniFi",
            "Tungsten Automation", "Yeastar", "Yubico"]


    let navigate = useNavigate();

    useEffect(() => {
        const storedSession = sessionStorage.getItem("selectedSession");
        if (storedSession) {
            setStoredSession(storedSession);
        }
    }, []);

    useEffect(() => {
        const isValidSession =
            storedSession !== null &&
            storedSession !== undefined &&
            String(storedSession).trim() !== '';

        if (isValidSession) {
            navigate('scansession');
        }
    }, [storedSession]);

    const onSelectSessionClick = (session) => {
        // Block navigation if offline
        if (!isOnline) {
            console.log('Cannot navigate - device is offline');
            return;
        }
        
        sessionStorage.setItem("selectedSession", session);
        navigate(`scansession`);
    }

    const handleSendTicketNumber = () => {
        // Block navigation if offline
        if (!isOnline) {
            console.log('Cannot navigate - device is offline');
            return;
        }
        
        navigate(`contact/${code}`);
    }

    return (
        <>
            <Navbar />
            <Banner />
            <div className='container mt-4 mb-5 page-container'>
                <h1 className='text text-dark fw-semibold fs-3 m-3'>Lead erfassen</h1>
                <div className='content m-3'>

                    <h3 className='text text-dark fw-semibold fs-3 mb-3'>Bereit zum Scannen</h3>

                    <p className='text text-secondary fs-6'>
                        Scannen Sie den QR-Code auf dem Namensschild des Kunden, indem Sie auf den untenstehenden Button tippen.
                    </p>

                    {/* <a className='scan-link' href="intent://camera/#Intent;end">Android: QR-Codeleser herunterladen</a> <br></br>
                          <a className='scan-link' href="photos-redirect://">iOS: QR-Scanner herunterladen</a>  <br></br> <br></br>
                          <a className='scan-link' href="/contact/609757863771">Contact Formular</a> */}

                    <div className='mb-3'>
                        <QRScanner isSessionCheckin={false} />
                    </div>

                    <p className='text text-secondary fs-6'>
                        Wenn der Scan auf Ihrem Gerät nicht funktioniert, können Sie die Ticketnummer eingeben, welche oberhalb des QR-Codes auf dem Namensschild des Kunden abgedruckt ist.
                    </p>

                    <div className="input-group mb-3">
                        <input 
                            type="number" 
                            className="form-control continue-input" 
                            pattern={[0 - 9]} 
                            placeholder="Ticketnummer eingeben" 
                            aria-label="Recipient's username" 
                            aria-describedby="basic-addon2" 
                            onChange={(e) => setCode(e.currentTarget.value)} 
                            value={code}
                            disabled={!isOnline}
                        />
                        <div className="input-group-append">
                            <button 
                                className='btn continue-btn ps-4 pe-4' 
                                onClick={handleSendTicketNumber}
                                disabled={!isOnline}
                                style={{ opacity: isOnline ? 1 : 0.6, cursor: isOnline ? 'pointer' : 'not-allowed' }}
                            >
                                Senden
                            </button>
                        </div>
                    </div>
                </div>

                <div className="content m-3">
                    <h3 className='text text-dark fw-semibold fs-3 mb-3'>Session Check-In</h3>

                    <p className='text text-secondary fs-6 mb-2'>
                        Wählen Sie die Session an um die Personen einzuchecken.
                    </p>

                    <div className="form-floating">
                        <div className="input-group mb-3">
                            <select 
                                className="form-select" 
                                style={{ paddingLeft: "12px" }} 
                                id="floatingSelect" 
                                value={selectedSession} 
                                onChange={(e) => setSelectedSession(e.target.value)}
                                disabled={!isOnline}
                            >
                                <option className='ps-2' value=""></option>
                                {sessionItems.map(session => (
                                    <option className='ps-2' value={session}>{session}</option>
                                ))}
                            </select>
                            <div className="input-group-append">
                                <button 
                                    className='btn continue-btn ps-4 pe-4' 
                                    onClick={() => onSelectSessionClick(selectedSession)}
                                    disabled={!isOnline}
                                    style={{ opacity: isOnline ? 1 : 0.6, cursor: isOnline ? 'pointer' : 'not-allowed' }}
                                >
                                    Senden
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='content m-3'>
                    <h3 className='text text-dark fw-semibold fs-3 mb-3'>Hilfebereich</h3>

                    <p className='text text-dark fs-6 fw-bold mb-1'>
                        Wo finden Sie die Ticketnummer?
                    </p>

                    <p className='text text-secondary fs-6 mb-2'>
                        Falls der QR-Scan bei Ihnen nicht funktioniert: Die Ticketnummer ist neben dem QRCode auf dem Namensschild aufgedruckt.
                    </p>

                    <img className='img-fluid mb-3' src={imgBadge1}></img>

                    <p className='text text-dark fs-6 fw-bold mb-1'>
                        Der Kunde hat kein Namensschild
                    </p>

                    <p className='text text-secondary fs-6 mb-2'>
                        Wenn der Kunde sein Namensschild nicht zur Hand hat, kann auch der QR-Code auf dem Eintrittsticket gescannt werden, welches dem Kunden per Mail zugestellt wurde.
                    </p>

                    <img className='img-fluid mb-3' src={imgBadge2}></img>

                    <p className='text text-dark fs-6 fw-bold mb-1'>
                        Detaillierter Leitfaden
                    </p>

                    <p className='text text-secondary fs-6 mb-2'>
                        Benötigen Sie weitere Unterstützung? Den detaillierten Leitfaden zur Leadlösung finden Sie auf unserer Website:
                    </p>

                    <a href='https://connect-fachmesse.ch/Handouts-Anleitungen/' target='blank'>https://connect-fachmesse.ch/Handouts-Anleitungen/</a>
                </div>
            </div>
        </>
    )
}

export default Scan